// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useRequestClientOnboarderService: () => UseMutationResult<
  void,
  string,
  {
    operator: string;
    registrar: string;
    clientOnboarder: string;
    upgrader: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['requestRegistryClientOnboarder', ledgerApi, party],
    mutationFn: async ({ operator, registrar, clientOnboarder, upgrader }) => {
      return ledgerApi.requestRegistryClientOnboarderService(
        operator,
        registrar,
        clientOnboarder,
        upgrader,
      );
    },
    retry: false,
  });
};

export default useRequestClientOnboarderService;
